import { Component, input } from '@angular/core';

@Component({
  selector: 'app-report-title',
  templateUrl: './report-title.component.html',
  styleUrl: './report-title.component.scss',
})
export class ReportTitleComponent {
  public readonly textCenter = input<boolean>();
  public readonly textRight = input<boolean>();
}
